import { render, staticRenderFns } from "./FaenaSmolt.vue?vue&type=template&id=a11f39d0&scoped=true"
import script from "./FaenaSmolt.vue?vue&type=script&lang=js"
export * from "./FaenaSmolt.vue?vue&type=script&lang=js"
import style0 from "./FaenaSmolt.vue?vue&type=style&index=0&id=a11f39d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11f39d0",
  null
  
)

export default component.exports